// CertificateOfGoodStanding.jsx
import React from "react";

export default function CertificateOfGoodStanding() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Certificate of Good Standing
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Certificate of Good Standing for Companies
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists companies in obtaining Certificates of
            Good Standing for legal transactions, international business,
            banking requirements, and compliance verification purposes.
          </p>
          <p className="text-gray-700">
            From compliance status verification through MCA portal to
            application preparation, digital signature coordination, and
            apostille/legalization support, the process ensures swift issuance
            of authoritative compliance certificates.
          </p>
        </div>

        {/* Right: Image (square for consistency - Different image) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184296/pexels-photo-3184296.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Corporate compliance documents and good standing certificate"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Certificate of Good Standing
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps verify and compile company information
              required for Good Standing certificate issuance through MCA.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Company incorporation details (Certificate of Incorporation, CIN).</li>
                <li>PAN card of the company.</li>
                <li>
                  Authorized signatory details including Director KYC, DSC
                  (Digital Signature Certificate), and board resolution.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides specialized corporate secretarial services for
              compliance verification and certification requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Corporate Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Comprehensive knowledge of MCA compliance requirements,
                  Companies Act provisions, and Good Standing certification for
                  domestic and international business transactions.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Filing Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise compliance status verification, MCA portal filings,
                  document authentication, and certificate issuance coordination
                  with minimal processing delays.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Service
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end support from compliance audit through application,
                  DSC coordination, apostille/legalization, and delivery of
                  certified true copies for banking, legal, and international use.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
